import React, { useState, useEffect } from "react";
import copy from "../../assets/images/logo.png";
import { useSnackbar } from 'notistack';

import "./Footer.scss";

const Footer: React.FC = () => {


  return (
    <div className="footer-wrapper ">
      <div className="footer-grid">
     <div>
      <img src={copy} style={{width:'40%'}}/>
        <div
            style={{
              fontSize: 16,
              padding: "0px 0px 5px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <p style={{ fontWeight: 400,              fontSize: 14,
 color: "rgb(102, 102, 102)" }}>
  Trade Simple: Your trusted platform for smarter, faster, and more confident trading.


            </p>
          </div>
          <div className="media flex-item">
              <div
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: 10000,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid rgb(211 211 211 / 59%)",
                }}
              >
                <a href="https://x.com/TradeSimple45" style={{ color: '#784dcc'}}>
                  <i className="fab fa-x-twitter"></i>
                </a>
              </div>
              <div
                style={{
                  zIndex:1000,
                  width: 40,
                  height: 40,
                  borderRadius: 10000,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid rgb(211 211 211 / 59%)",
                }}
              >
                <a href="https://t.me/tradesimple45" style={{ color: '#784dcc'}}>
                  <i className="fab fa-telegram"></i>
                </a>
              </div>

              <div
                style={{
                  zIndex:1000,
                  width: 40,
                  height: 40,
                  borderRadius: 10000,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid rgb(211 211 211 / 59%)",
                }}
              >
                <a href="https://wa.me/+12267981010" style={{ color: '#784dcc'}}>
                  <i className="fab fa-whatsapp"></i>
                </a>
              </div>
            
            
              <div
                style={{
                  zIndex:1000,
                  width: 40,
                  height: 40,
                  borderRadius: 10000,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid rgb(211 211 211 / 59%)",
                }}
              >
                <a href="https://www.tiktok.com/@tradesimple45" style={{ color: '#784dcc'}}>
                  <i className="fab fa-tiktok"></i>
                </a>
              </div>

              <div
                style={{
                  zIndex:1000,
                  width: 40,
                  height: 40,
                  borderRadius: 10000,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid rgb(211 211 211 / 59%)",
                }}
              >
                <a href="https://www.instagram.com/tradesimple45/" style={{ color: '#784dcc'}}>
                  <i className="fab fa-instagram"></i>
                </a>
              </div>

              <div
                style={{
                  zIndex:1000,
                  width: 40,
                  height: 40,
                  borderRadius: 10000,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  border: "1px solid rgb(211 211 211 / 59%)",
                }}
              >
                <a href="https://www.facebook.com/profile.php?id=100077561889412" style={{ color: '#784dcc'}}>
                  <i className="fab fa-facebook"></i>
                </a>
              </div>

             
            
            </div>
     </div>
<div className="mon-no"></div>
        <div>
          <p style={{ fontSize: 14 }}>COMPANY</p>
          <div
            style={{
              fontSize: 14,
              padding: "20px 0px 5px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "rgb(102, 102, 102)" }} href="./about">
              About
            </a>
          </div>
       
          <div
            style={{
              fontSize: 14,
              padding: "5px 0px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "rgb(102, 102, 102)" }} href="./#why">
              Benefits
            </a>
          </div>
          <div
            style={{
              fontSize: 14,
              padding: "5px 0px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "rgb(102, 102, 102)" }} href="./#plans">
              Plans
            </a>
          </div>
          <div
            style={{
              fontSize: 14,
              padding: "5px 0px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "rgb(102, 102, 102)" }} href="./testimonials">
              Testimonials
            </a>
          </div>
        </div>

        <div>
          <p style={{ fontSize: 14 }}>SUPPORT</p>
          <div
            style={{
              fontSize: 14,
              padding: "20px 0px 5px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "rgb(102, 102, 102)" }} href="mailto:info@tradesimple.ca">
              Email Support
            </a>
          </div>
          <div
            style={{
              fontSize: 14,
              padding: "5px 0px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "rgb(102, 102, 102)" }} href="https://t.me/tradesimple45">
              Telegram Support
            </a>
          </div>
         
         
        </div>
   

        <div>
          <p style={{ fontSize: 14 }}>OTHERS</p>
          
          <div
            style={{
              fontSize: 14,
              padding: "20px 0px 5px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "rgb(102, 102, 102)" }} href="./terms-of-use">
              Terms of Use
            </a>
          </div>
          <div
            style={{
              fontSize: 14,
              padding: "5px 0px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "rgb(102, 102, 102)" }} href="./disclaimer">
              Disclaimer
            </a>
          </div>
         
        </div>

        
           <div>
          {/* <p style={{ fontSize: 14 }}>PLATFORM</p>
          <div
            style={{
              fontSize: 14,
              padding: "20px 0px 5px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "rgb(102, 102, 102)" }} href="/">
              Terms
            </a>
          </div>
          <div
            style={{
              fontSize: 14,
              padding: "5px 0px",
              fontFamily: "var(--font-regular)",
            }}
          >
            {" "}
            <a style={{ fontWeight: 400, color: "rgb(102, 102, 102)" }} href="/">
              Privacy
            </a>
          </div> */}
        </div>

   
      </div>

      <hr className="custom-hr" />
      
      <div className="pollll" >
        <div style={{ fontSize: 12, color: "rgb(102, 102, 102)", lineHeight: 1.6 }}>
          <p style={{ marginBottom: 15 }}>
            <strong style={{ fontWeight: 700,color:'#784dcc' }}>Futures Risk Disclosure</strong><br/>
            Futures and forex trading contains substantial risk and is not for every investor. An
            investor could potentially lose all or more than the initial investment. Risk capital is
            money that can be lost without jeopardizing ones' financial security or life style. Only risk
            capital should be used for trading and only those with sufficient risk capital should
            consider trading. Past performance is not necessarily indicative of future results.
          </p>
          
          <p style={{ marginBottom: 15 }}>
            <strong style={{ fontWeight: 700,color:'#784dcc' }}>Hypothetical Performance Disclosure</strong><br/>
            Hypothetical performance results have many inherent limitations, some of which are
            described below. No representation is being made that any account will or is likely to
            achieve profits or losses similar to those shown; in fact, there are frequently sharp
            differences between hypothetical performance results and the actual results
            subsequently achieved by any particular trading program. One of the limitations of
            hypothetical performance results is that they are generally prepared with the benefit of
            hindsight. In addition, hypothetical trading does not involve financial risk, and no
            hypothetical trading record can completely account for the impact of financial risk of
            actual trading. for example, the ability to withstand losses or to adhere to a particular
            trading program in spite of trading losses are material points which can also adversely
            affect actual trading results. There are numerous other factors related to the markets in
            general or to the implementation of any specific trading program which cannot be fully
            accounted for in the preparation of hypothetical performance results and all which can
            adversely affect trading results.
          </p>
          
          <p style={{ marginBottom: 15 }}>
            <strong style={{ fontWeight: 700,color:'#784dcc' }}>Testimonials Disclaimer</strong><br/>
            Testimonials appearing on this website may not be representative of other clients or
            customers and is not a guarantee of future performance or success.
          </p>
          
          <p style={{ marginBottom: 15 }}>
            <strong style={{ fontWeight: 700,color:'#784dcc' }}>Live Trade Room</strong><br/>
            This presentation is for educational purposes only and the opinions expressed are those
            of the presenter only. All trades presented should be considered hypothetical and
            should not be expected to be replicated in a live trading account.
          </p>
        </div>
      </div>
      
      <hr className="custom-hr" />
      
      <div className="mx">
        <div className="footer-container">
          <div className="footer-content flex-item">
            <div className="footer-second-content flex-item">
              {/* <div className="app-icon flex-item">
                <AppStoreIcon />
                <GooglePayIcon />
              </div> */}

              <div>
                <p style={{ color: "black", fontSize: 13.5 }}>
                  ©2024 <a href="#" style={{color:'#784dcc'}}>Trade Simple</a>
                </p>
             
              </div>
            </div>
         
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
